// extracted by mini-css-extract-plugin
export var modal = "_t9-0";
export var table = "_t9-1";